import { IStyle } from '@fluentui/react';
import { CommonStyles, IH2OTheme, Sizes } from '@h2oai/ui-kit';

export interface ISummaryCardListWidgetStyles {
  root?: IStyle;
  loader?: IStyle;
  emptyMessage?: IStyle;
}

export interface ISummaryCardListWidgetClassNames {
  root: string;
  loader: string;
  emptyMessage: string;
}

export const summaryCardListWidgetStylesDefault = (theme: IH2OTheme): Partial<ISummaryCardListWidgetStyles> => ({
  root: {
    display: 'flex',
    gap: Sizes.padding,
    overflowX: 'auto',
    overflowY: 'hidden',
    height: '100%',
    position: 'relative',
  },
  loader: {
    flex: 1,
    backgroundColor: theme.semanticColors?.contentBackground,
    borderRadius: Sizes.borderRadius,
    ...CommonStyles.flexCenterVertically,
  },
  emptyMessage: {
    flex: 1,
    backgroundColor: theme.semanticColors?.contentBackground,
    borderRadius: Sizes.borderRadius,
  },
});
